// 敏感词处理
import publicpb from '../../base/public.pb';
import PbAjax from '../../lib/pbajax';
import sensitivepb from './index.pb';
import url from 'c-url';
import Cache from 'c-cache';

let cache = new Cache({
    prefix: 'pcuplive/sensitivewords'
});
let pbajax = new PbAjax();

let sensitive = {

    getDataFromServer() {
        let _lang = UP.Global.siteLanguage;
        let localLast = cache.getCache('lastTime/' + _lang);
        let localExtLast = cache.getCache('extLastTime/' + _lang);

        let data = new sensitivepb.SensitiveWords.Get.Request({
            lastTime: localLast ? parseInt(localLast) : 0,
            extLastTime: localExtLast ? parseInt(localExtLast) : 0
        });
        
        pbajax.do(
            {
                service: 'service',    
                api: '/sensitive/words/get',  
                header: {
                    lang: _lang
                }
            }, 

            data, 

            (res)=>{
                let dataWrap = publicpb.Result.decode(res);
                let data;

                if (dataWrap.code == 1) {
                    data = sensitivepb.SensitiveWords.Get.Response.decode(dataWrap.data.value);
                    // console.log('sensitive:', data);
                    // 存储敏感词主库的最后更新时间
                    cache.setCache('lastTime/' + _lang, longToString(data.updateTime));
                    cache.setCache('extLastTime/' + _lang, longToString(data.extUpdateTime));
                    this.localSensitiveUpdate(data);
                } 
            }
        );
    },

    localSensitiveUpdate(data) {
        let _lang = UP.Global.siteLanguage;
        let list = data.words;
        let locals = cache.getCache('words/' + _lang);

        if (!locals) {
            // list = this.getWordsByLang(_lang, list);
            list = this.getValidPureWordList(list);
            cache.setCache('words/' + _lang, list);
            return;
        }

        let newLocal = this.update(locals, list);
        
        cache.setCache('words/' + _lang, newLocal);

    },

    // 不区分status（是否被删除 0 无效的 1 有效）
    getWordsByLang(lang, list) {
        let arr = [];
        list.forEach((item, inx)=>{
            if (item.lang == lang) {
                arr.push(item);
            }
        });

        return arr;
    },

    // 获得有效的敏感词纯数组
    getValidPureWordList(list) {
        let arr = [];
        list.forEach((item, inx)=>{
            if (item.status) {
                arr.push(item.content);
            }
        });

        return arr;
    },

    update(localList, news) {
    
        news.forEach((item, inx)=>{
            if (item.status) {
                localList.push(item.content);
            } else {
                localList = this.delSomeByValue(localList, item.content);
            }
        });

        return [...localList];
    },    

    delSomeByValue(arr, item) {
        for (let i = arr.length; i--;) {
            let val = arr[i];
            if (val == item) {
                arr.splice(i, 1);
            }
        }

        return [...arr];
    },

    getLocalWords() {
        let _lang = UP.Global.siteLanguage;
        
        return cache.getCache('words/' + _lang)
    },

    filter(content) {
        if (!content) {
            return content;
        }
        let localList = this.getLocalWords();
        
        if (localList && localList.length > 0) {
            localList = localList.map((item, inx)=>{
                item = item.replace(/[\ |\~|\`|\!|\@|\#|\$|\%|\^|\&|\*|\(|\)|\-|\_|\+|\=|\||\\|\[|\]|\{|\}|\;|\:|\"|\'|\,|\<|\.|\>|\/|\?]/g, function (s, i) {
                    return `\\${s}`;
                })
                return '(' + item + ')';
            });

            let reg = new RegExp(localList.join('|'), 'gi');
            
            return content.replace(reg, '***');
            
        } else {
            return content;
        }
    },

    check(content) {
        let localList = this.getLocalWords();
        
        if (localList && localList.length > 0) {
            localList = localList.map((item, inx)=>{
                item = item.replace(/[\ |\~|\`|\!|\@|\#|\$|\%|\^|\&|\*|\(|\)|\-|\_|\+|\=|\||\\|\[|\]|\{|\}|\;|\:|\"|\'|\,|\<|\.|\>|\/|\?]/g, function (s, i) {
                    return `\\${s}`;
                })
                return '(' + item + ')';
            });

            let reg = new RegExp(localList.join('|'), 'gi');

            return content.match(reg) ? false : true;
        } else {
            return true;
        }
    }
};

export default sensitive;


// WEBPACK FOOTER //
// ./js/component/sensitive-words/index.js